// extracted by mini-css-extract-plugin
export default {"card-action":"AddressCard_card-action__rBzqA","address-card":"AddressCard_address-card__WyC8O"};